export interface ProjectCommitteesCategoriesResult {
  projectsCommitteeCategory: string[];
}
